import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React, { useMemo } from 'react'
import { Table } from 'react-bootstrap';

const ReportPreviewTable = ({data}) => {
    // Dynamically generate columns based on the data keys 
    const columns = useMemo(() => {
        if (!data || data.length === 0) return [];

        return Object.keys(data[0]).map(key => ({
            accessorKey: key,
            header: key.replace(/_/g, ' ').toUpperCase(),
            cell: info => info.getValue()?.toString() || '-'
        }));
    }, [data]);

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    if (!data || data.length === 0) {
        return <div className="text-center pt-5 text-muted">No data found for the selected filters.</div>
    }

  return (
    <div className="mt-4 border-top pt-4">
        {/**<h5 className="mb-3 text-secondary">Data Preview (Last 50 Records)</h5>*/}
        <div className="table-responsive" style={{ maxHeight: '400px'}}>
            <Table hover striped bordered size='sm' className='align-middle'>
                <thead className='table-secondary sticky-top'>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id} style={{ fontSize: '0.85rem'}}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    </div>
  )
}

export default ReportPreviewTable